import { defineMessages } from 'react-intl';

export default defineMessages({
  password: {
    id: 'RESET_PASSWORD.password',
    defaultMessage: 'New password',
  },
  reset: {
    id: 'RESET_PASSWORD.reset',
    defaultMessage: 'Reset password',
  },
});



// WEBPACK FOOTER //
// ./components/molecules/ResetPassword/messages.js